import { HealthcareProviderConstraint } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { TranslatableText } from '@dreryk/react-common';
import { StorageUsageIndicator } from '@dreryk/react-components';

import { dataStorageTranslationKeys } from '../../translations';
import { PurchasePackageModalButton } from '../common/PurchasePackageModal/PurchasePackageModalButton';

import { StyledDataStoragePanel } from './DataStoragePanel.styled';

const EXTERNAL_DOCUMENTATION_STORAGE_USAGE_DESCRIPTION: TranslatableText[] = [
   dataStorageTranslationKeys.externalImportFiles,
];

type DataStoragePanelProps = {
   readonly healthcareProviderConstraint: HealthcareProviderConstraint;
};

export const DataStoragePanel = (props: DataStoragePanelProps): JSX.Element => {
   return (
      <StyledDataStoragePanel>
         <StorageUsageIndicator
            label={dataStorageTranslationKeys.externalDocumentation}
            usageInBytes={props.healthcareProviderConstraint.externalDocumentationStorageUsage}
            limitInBytes={props.healthcareProviderConstraint.externalDocumentationStorageLimit}
            description={EXTERNAL_DOCUMENTATION_STORAGE_USAGE_DESCRIPTION}
            testId={'externalDocumentation'}
         />
         <PurchasePackageModalButton
            label={dataStorageTranslationKeys.purchasePackageButtonLabel}
            modalTitle={dataStorageTranslationKeys.purchasePackageModalTitle}
         />
      </StyledDataStoragePanel>
   );
};
